import { memo } from 'react';

import type { SVGProps } from 'react';
const SvgIconBadgeVerified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 21"
    role="img"
    className={props.className}
    {...props}
  >
    <circle cx={10.5} cy={10.5} r={10.25} fill="#B7C0CD" stroke="#6D7888" strokeWidth={0.5} />
    <path fill="#ADB6C3" d="M10.5 20.5c5.523 0 10-4.477 10-10s-4.477-10-10-10z" />
    <path
      stroke="#6D7888"
      strokeWidth={0.5}
      d="m16.5 8.938-6-4.438-6 4.274v3.288m12-3.124v3.288l-6 4.274-6-4.438m12-3.124-6 4.439-3.943-2.893M4.5 12.062l2.057-1.578m8.057-.066L10.5 7.458l-3.943 3.026"
    />
  </svg>
);
const Memo = memo(SvgIconBadgeVerified);
export default Memo;
